"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCoupler = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _cccisdFormik = require("cccisd-formik");
var _helpers = require("../../helpers");
var _TabName = _interopRequireDefault(require("./TabName"));
var _PageWidth = _interopRequireDefault(require("./PageWidth"));
var _Introduction = _interopRequireDefault(require("./Introduction"));
var _LearningObjectives = _interopRequireDefault(require("./LearningObjectives"));
var _Presenters = _interopRequireDefault(require("./Presenters"));
var _IconAndDescription = _interopRequireDefault(require("./IconAndDescription"));
var _FinalTestInstructions = _interopRequireDefault(require("./FinalTestInstructions"));
var _CeApprovalStatements = _interopRequireDefault(require("./CeApprovalStatements"));
var _SpecialAssistance = _interopRequireDefault(require("./SpecialAssistance"));
var _Acknowledgements = _interopRequireDefault(require("./Acknowledgements"));
var _users = _interopRequireDefault(require("cccisd-icons/users4"));
var _database = _interopRequireDefault(require("cccisd-icons/database"));
var _stopwatch = _interopRequireDefault(require("cccisd-icons/stopwatch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var initialValues = {
  toggle: false,
  tabName: 'Course Description',
  pageWidth: 'medium',
  introduction: {
    title: '',
    main: '',
    courseSections: [{
      heading: '',
      description: '',
      key: 0
    }]
  },
  learningObjectives: {
    title: '',
    sections: [{
      heading: '',
      statement: '',
      objectives: [{
        text: '',
        key: 0
      }],
      key: 0
    }]
  },
  presenters: {
    title: '',
    sections: [{
      name: '',
      title: '',
      position: '',
      bio: '',
      image: '',
      key: 0
    }]
  },
  audience: {
    title: '',
    description: '',
    icon: 'default',
    iconColor: '#0361B0',
    imageDetails: ''
  },
  creditHours: {
    title: '',
    description: '',
    icon: 'default',
    iconColor: '#0361B0',
    imageDetails: ''
  },
  duration: {
    title: '',
    description: '',
    icon: 'default',
    iconColor: '#0361B0',
    imageDetails: ''
  },
  finalTestInstructions: {
    title: '',
    statement: '',
    bullets: [{
      text: '',
      key: 0
    }]
  },
  ceApprovalStatements: {
    title: '',
    sections: [{
      title: '',
      subtitle: '',
      description: '',
      key: 0
    }]
  },
  specialAssistance: {
    title: '',
    content: ''
  },
  acknowledgements: {
    title: '',
    content: '',
    displayInModal: false
  },
  tableOfContents: false
};
var validate = function validate(values, errors) {
  var localErrors = {};
  if (values.courseDescription.toggle) {
    if (!values.courseDescription.tabName) {
      localErrors['courseDescription.tabName'] = 'Tab Name is required';
    }
    var keysOfInterest = Object.keys(initialValues).filter(function (key) {
      return !['toggle', 'tabName'].includes(key);
    });
    var valuesOfInterest = (0, _pick2["default"])(values.courseDescription, keysOfInterest);
    var onlyValues = Object.values(valuesOfInterest);
    if (onlyValues.every(function (item) {
      return item === '';
    })) {
      var _iterator = _createForOfIteratorHelper(keysOfInterest),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          localErrors["courseDescription.".concat(key)] = 'At least one of the course description fields must be non-empty';
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  (0, _assign2["default"])(errors, localErrors);
  return !Object.keys(localErrors).length;
};
var formCoupler = exports.formCoupler = {
  initialValues: initialValues,
  validate: validate,
  errorTab: 'courseDescription',
  key: 'courseDescription'
};
var FormCourseDescription = function FormCourseDescription(_ref) {
  var formProps = _ref.formProps;
  var renderToggleField = function renderToggleField() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseDescription.toggle",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Course Description Tab",
        tooltip: "Should we show a Course Description tab?"
      }),
      autoFocus: true
    }));
  };
  var renderConditionalFields = function renderConditionalFields() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseDescription.tableOfContents",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Table of Contents",
        tooltip: "Should we show a Table of Contents?"
      })
    }), /*#__PURE__*/_react["default"].createElement(_TabName["default"], null), /*#__PURE__*/_react["default"].createElement(_PageWidth["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_Introduction["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_LearningObjectives["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_Presenters["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_IconAndDescription["default"], {
      heading: "Audience",
      name: "audience",
      DefaultIcon: _users["default"],
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_FinalTestInstructions["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_IconAndDescription["default"], {
      heading: "Credit Hours",
      name: "creditHours",
      DefaultIcon: _database["default"],
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_IconAndDescription["default"], {
      heading: "Duration",
      name: "duration",
      DefaultIcon: _stopwatch["default"],
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_CeApprovalStatements["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_SpecialAssistance["default"], {
      formProps: formProps
    }), /*#__PURE__*/_react["default"].createElement(_Acknowledgements["default"], {
      formProps: formProps
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderToggleField(), formProps.values.courseDescription.toggle && renderConditionalFields());
};
var _default = exports["default"] = FormCourseDescription;